import styled from 'styled-components';
import { SmallText, HeadingFour } from '../../typography';
import { COLOR_GREEN, COLOR_WHITE } from '../../../assets/styles/colors';

export const LoanStatusSC = styled.div``;

export const SoldSC = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const IconWrapper = styled.div`
  margin-right: 24px;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
`;

export const SoldText = styled(SmallText)`
  color: #9d9ca8;
  text-align: left;
`;

export const SoldTextWhite = styled(SmallText)`
  color: white;
  text-align: left;
`;

export const DetailWrapper = styled.div`
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  text-align: left;
`;

export const ValueText = styled(HeadingFour)`
  color: ${({ sold }) => (sold ? COLOR_GREEN : COLOR_WHITE)};
  text-align: left;
`;
